import { Receipt } from "lucide-react";

import { SettingsPageLayout } from "components/settings/settings-page-layout";

import { BillingInfoCard } from "./billing-info-card";
import { PaymentMethodCard } from "./payment-method-card";

export const BillingDetailsPage = () => {
  return (
    <SettingsPageLayout
      pageTitle={{
        icon: Receipt,
        title: "Billing Details",
        description:
          "Manage your payment method and contact information used on invoices.",
      }}
    >
      <div className="mx-auto max-w-5xl space-y-4">
        <PaymentMethodCard />
        <BillingInfoCard />
      </div>
    </SettingsPageLayout>
  );
};
